import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "workspace",
    class: ['restaurante-producao', {
      'is-fullscreen': _vm.isFullscreen
    }]
  }, [_c('section', {
    staticClass: "card card-custom kds-shell",
    attrs: {
      "aria-busy": _vm.painelLoading ? 'true' : 'false'
    }
  }, [_c('h1', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.titulo) + " — painel de produção")]), _c('div', {
    staticClass: "kds-commandbar"
  }, [_c('div', {
    staticClass: "kds-station"
  }, [_c('span', {
    staticClass: "kds-station-indicator",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.titulo))]), _c('small', [_vm._v(_vm._s(_vm.totalTicketsLabel))])]), _vm.atrasadosTickets ? _c('span', {
    staticClass: "kds-overdue-pill"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.overdueTicketsLabel) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "kds-controls",
    attrs: {
      "aria-label": "Controles da produção"
    }
  }, [_c('label', {
    staticClass: "kds-sector-filter",
    attrs: {
      "for": "setor_producao_id"
    }
  }, [_c('i', {
    staticClass: "fas fa-filter",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Filtrar por setor")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.setor_producao_id,
      expression: "filters.setor_producao_id"
    }],
    attrs: {
      "id": "setor_producao_id"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filters, "setor_producao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.getPainel]
    }
  }, _vm._l(_vm.setorOptions, function (option) {
    return _c('option', {
      key: String(option.value),
      domProps: {
        "value": option.value
      }
    }, [_vm._v(" " + _vm._s(option.text) + " ")]);
  }), 0)]), _c('button', {
    staticClass: "kds-auto-refresh",
    class: {
      active: _vm.autoRefresh
    },
    attrs: {
      "type": "button",
      "aria-pressed": _vm.autoRefresh ? 'true' : 'false'
    },
    on: {
      "click": function click($event) {
        _vm.autoRefresh = !_vm.autoRefresh;
      }
    }
  }, [_c('span', {
    staticClass: "kds-live-dot",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.autoRefresh ? "Tempo real" : "Pausado") + " ")]), _c('span', {
    staticClass: "kds-last-refresh"
  }, [_vm._v(_vm._s(_vm.lastRefreshLabel))]), _vm.exibirMesasAtalho ? _c('router-link', {
    staticClass: "kds-icon-button",
    attrs: {
      "to": {
        name: 'restauranteMesas'
      },
      "title": "Abrir mesas",
      "aria-label": "Abrir mesas"
    }
  }, [_c('i', {
    staticClass: "fas fa-chair",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _c('button', {
    staticClass: "kds-icon-button",
    attrs: {
      "type": "button",
      "disabled": _vm.painelLoading,
      "title": "Atualizar produção",
      "aria-label": "Atualizar produção"
    },
    on: {
      "click": _vm.getPainel
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.painelLoading
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('button', {
    staticClass: "kds-icon-button kds-fullscreen-button",
    attrs: {
      "type": "button",
      "title": _vm.isFullscreen ? 'Sair da tela cheia' : 'Usar tela cheia',
      "aria-label": _vm.isFullscreen ? 'Sair da tela cheia' : 'Usar tela cheia'
    },
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('i', {
    class: ['fas', _vm.isFullscreen ? 'fa-compress' : 'fa-expand'],
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)]), !_vm.restauranteProducaoEtapaUnica ? _c('nav', {
    staticClass: "kds-stage-tabs",
    attrs: {
      "aria-label": "Etapas da produção"
    }
  }, _vm._l(_vm.statusColumns, function (column) {
    return _c('button', {
      key: column.status,
      class: ["is-".concat(column.status), {
        active: _vm.activeColumn === column.status
      }],
      attrs: {
        "type": "button",
        "aria-current": _vm.activeColumn === column.status ? 'page' : null
      },
      on: {
        "click": function click($event) {
          _vm.activeColumn = column.status;
        }
      }
    }, [_vm._v(" " + _vm._s(column.label) + " "), _c('span', [_vm._v(_vm._s(_vm.ticketsPorColuna(column).length))])]);
  }), 0) : _vm._e(), _c('main', {
    class: ['kds-board', {
      'kds-board-etapa-unica': _vm.restauranteProducaoEtapaUnica
    }]
  }, _vm._l(_vm.statusColumns, function (column) {
    return _c('div', {
      key: column.status,
      class: ['kds-column', "is-".concat(column.status), {
        'is-mobile-active': _vm.activeColumn === column.status
      }]
    }, [_c('div', {
      class: ['kds-column-header', "kds-column-".concat(column.status)]
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(column.label))]), _c('small', [_vm._v(_vm._s(_vm.columnHelp(column.status)))])]), _c('div', {
      staticClass: "kds-column-counts"
    }, [_c('strong', [_vm._v(_vm._s(_vm.ticketsPorColuna(column).length))]), _c('span', [_vm._v(_vm._s(_vm.itemCountLabel(_vm.itensPorColuna(column).length)))])])]), _c('div', {
      staticClass: "kds-column-scroll"
    }, [!_vm.ticketsPorColuna(column).length ? _c('div', {
      staticClass: "kds-column-empty"
    }, [_c('i', {
      staticClass: "far fa-check-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._m(0, true)]) : _vm._e(), _vm._l(_vm.ticketsPorColuna(column), function (ticket) {
      return _c('article', {
        key: ticket.key,
        class: ['producao-ticket', "producao-card-".concat(ticket.status), {
          'producao-card-atencao': ticket.atencao,
          'producao-card-atrasado': ticket.atrasado
        }]
      }, [_c('button', {
        staticClass: "producao-ticket-header",
        attrs: {
          "type": "button",
          "aria-expanded": _vm.isTicketExpanded(ticket) ? 'true' : 'false'
        },
        on: {
          "click": function click($event) {
            return _vm.toggleTicket(ticket);
          }
        }
      }, [_c('div', {
        staticClass: "producao-ticket-identity"
      }, [_c('span', [_vm._v(_vm._s(_vm.itemTicketLabel(ticket.firstItem)))]), _c('strong', [_vm._v(_vm._s(_vm.itemMesaLabel(ticket.firstItem)))]), _c('small', [_vm._v(_vm._s(_vm.itemSetorLabel(ticket.firstItem)))])]), _c('div', {
        staticClass: "producao-ticket-badges"
      }, [_c('span', {
        staticClass: "producao-ticket-summary"
      }, [_vm._v(" " + _vm._s(_vm.itemCountLabel(ticket.items.length)) + " ")]), _c('span', {
        staticClass: "kds-timer",
        class: {
          'is-warning': ticket.atencao,
          'is-danger': ticket.atrasado
        }
      }, [_c('i', {
        staticClass: "far fa-clock",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.tempoDecorridoLabel(ticket.firstItem)) + " ")])]), _c('i', {
        class: ['fas', _vm.isTicketExpanded(ticket) ? 'fa-chevron-up' : 'fa-chevron-down'],
        attrs: {
          "aria-hidden": "true"
        }
      })]), _c('div', {
        staticClass: "producao-ticket-meta"
      }, [_c('span', [_vm._v(" Enviado " + _vm._s(_vm.formatDate(ticket.firstItem.enviado_at)) + " ")])]), _vm.ticketNextStatus(ticket) ? _c('div', {
        staticClass: "producao-ticket-actions"
      }, [_c('button', {
        staticClass: "btn font-weight-bold",
        class: _vm.ticketActionClass(_vm.ticketNextStatus(ticket)),
        attrs: {
          "type": "button",
          "disabled": _vm.isTicketUpdating(ticket)
        },
        on: {
          "click": function click($event) {
            _vm.updateTicketGroupStatus(ticket, _vm.ticketNextStatus(ticket));
          }
        }
      }, [_vm.isTicketUpdating(ticket) ? _c('i', {
        staticClass: "fas fa-spinner fa-spin",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e(), _c('span', [_vm._v(_vm._s(_vm.actionLabel(_vm.ticketNextStatus(ticket), true)))]), !_vm.isTicketUpdating(ticket) ? _c('i', {
        staticClass: "fas fa-arrow-right producao-action-arrow",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e()])]) : _vm._e(), _vm.isTicketExpanded(ticket) ? _c('div', {
        staticClass: "producao-ticket-items"
      }, _vm._l(ticket.comandas, function (grupo) {
        return _c('div', {
          key: grupo.key,
          staticClass: "producao-comanda-group"
        }, [_c('div', {
          staticClass: "producao-comanda-header"
        }, [_c('strong', [_vm._v(_vm._s(grupo.label))]), _c('span', [_vm._v(_vm._s(_vm.itemCountLabel(grupo.items.length)))])]), _vm._l(grupo.items, function (item) {
          return _c('div', {
            key: item.id,
            staticClass: "producao-ticket-item"
          }, [_c('div', {
            staticClass: "producao-produto"
          }, [_c('strong', [_vm._v(_vm._s(_vm.produtoDescricao(item)))]), _c('span', [_vm._v(_vm._s(_vm.quantidadeItem(item)))])]), _vm.observacaoLinhas(item).length ? _c('div', {
            staticClass: "producao-observacao"
          }, _vm._l(_vm.observacaoLinhas(item), function (linha, linhaIndex) {
            return _c('span', {
              key: linhaIndex
            }, [_vm._v(" " + _vm._s(linha) + " ")]);
          }), 0) : _vm._e(), _c('div', {
            staticClass: "producao-actions"
          }, [_vm.nextStatus(item.status) ? _c('button', {
            staticClass: "btn btn-sm btn-light-primary font-weight-bold",
            attrs: {
              "type": "button",
              "disabled": _vm.isItemUpdating(item)
            },
            on: {
              "click": function click($event) {
                _vm.updateStatus(item, _vm.nextStatus(item.status));
              }
            }
          }, [_vm.isItemUpdating(item) ? _c('i', {
            staticClass: "fas fa-spinner fa-spin",
            attrs: {
              "aria-hidden": "true"
            }
          }) : _vm._e(), _vm._v(" " + _vm._s(_vm.actionLabel(_vm.nextStatus(item.status))) + " ")]) : _vm._e()])]);
        })], 2);
      }), 0) : _vm._e()]);
    })], 2)]);
  }), 0), _c('div', {
    staticClass: "sr-only",
    attrs: {
      "aria-live": "polite",
      "aria-atomic": "true"
    }
  }, [_vm._v(" " + _vm._s(_vm.liveMessage) + " ")])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('strong', [_vm._v("Nenhum ticket nesta etapa")]), _c('span', [_vm._v("A próxima movimentação aparecerá aqui.")])]);
}];
export { render, staticRenderFns };